<template>
    <div v-if="revision && revision.length > 0">
        <div v-if="!isRevHistoryPage" class="text-h6 q-mb-md">
            Revision Notes
        </div>
        <div v-for="rev in sortedRevision" :key="rev.id" class="q-mb-md">
            <div :class="!isRevHistoryPage ? 'text-caption' : 'q-pb-xs q-pl-xs'" :style="!isRevHistoryPage ? '' : 'font-size: 1rem; font-weight: 500;'">Version {{ rev.version }} ({{ rev.releaseDate | date }})</div>
            <q-list separator bordered>
                <q-expansion-item v-if="rev.newFeatures && !isRevHistoryPage"
                                  icon="mdi-new-box"
                                  label="New & Enhanced Features">
                    <q-card>
                        <q-card-section v-html="rev.newFeatures" />
                    </q-card>
                </q-expansion-item>
                <q-expansion-item v-else-if="rev.newFeatures && isRevHistoryPage"
                                  v-model="expandedDisabled"
                                  :disable="expandedDisabled"
                                  :header-class="{ 'disabled-header': expandedDisabled }"
                                  icon="mdi-new-box"
                                  label="New & Enhanced Features">
                    <q-card>
                        <q-card-section v-html="rev.newFeatures" />
                    </q-card>
                </q-expansion-item>

                <q-expansion-item v-if="rev.fixes && !isRevHistoryPage"
                                  icon="mdi-auto-fix"
                                  label="Fixes">
                    <q-card>
                        <q-card-section v-html="rev.fixes" />
                    </q-card>
                </q-expansion-item>
                <q-expansion-item v-else-if="rev.fixes && isRevHistoryPage"
                                  v-model="expandedDisabled"
                                  :disable="expandedDisabled"
                                  :header-class="{ 'disabled-header': expandedDisabled }"
                                  icon="mdi-auto-fix"
                                  label="Fixes">
                    <q-card>
                        <q-card-section v-html="rev.fixes" />
                    </q-card>
                </q-expansion-item>

                <q-expansion-item v-if="rev.oemChanges && !isRevHistoryPage"
                                  icon="mdi-information-outline"
                                  label="OEM Changes">
                    <q-card>
                        <q-card-section v-html="rev.oemChanges" />
                    </q-card>
                </q-expansion-item>
                <q-expansion-item v-else-if="rev.oemChanges && isRevHistoryPage"
                                  v-model="expandedDisabled"
                                  :disable="expandedDisabled"
                                  :header-class="{ 'disabled-header': expandedDisabled }"
                                  icon="mdi-information-outline"
                                  label="OEM Changes">
                    <q-card>
                        <q-card-section v-html="rev.oemChanges" />
                    </q-card>
                </q-expansion-item>

                <q-expansion-item v-if="!rev.newFeatures && !rev.fixes && !rev.oemChanges && !isRevHistoryPage"
                                  icon="mdi-information-outline"
                                  label="Other">
                    <q-card>
                        <q-card-section v-html="rev.revision" />
                    </q-card>
                </q-expansion-item>
                <q-expansion-item v-else-if="!rev.newFeatures && !rev.fixes && !rev.oemChanges && isRevHistoryPage"
                                  v-model="expandedDisabled"
                                  :disable="expandedDisabled"
                                  :header-class="{ 'disabled-header': expandedDisabled }"
                                  icon="mdi-information-outline"
                                  label="Other">
                    <q-card>
                        <q-card-section v-html="rev.revision" />
                    </q-card>
                </q-expansion-item>
            </q-list>
        </div>
    </div>
</template>
<script>
    import { ref } from 'vue'

    export default {
        name: 'revision-notes',
        props: {
            revision: Array,
            isRevHistoryPage: {
                default: false,
                type: Boolean
            },
        },
        data() {
            return {
                expandedDisabled: ref(true),
            }
        },
        computed: {
            sortedRevision() {
                if (!this.revision) return null
                return this.revision.sort((a, b) => new Date(b.releaseDate) - new Date(a.releaseDate))
            }

        }
    }
</script>
<style scoped>

    >>> .disabled-header {
        opacity: 1 !important;
        cursor: default !important;
    }

        >>> .disabled-header * {
            cursor: default !important;
        }
</style>
